import React from 'react';
import { 
  PackagedPueblo,
} from './products/index';

const Products = () => {
  return (
    <section id="productos" className="bg-gradient-to-br from-gray-50 to-green-50">
      {/* <IlustracionPR /> */}
      <PackagedPueblo />
    </section>
  );
};

export default Products;